module.exports = __webpack_public_path__ + "img/full5-min.1db97540.png";